import React, { useState } from 'react';
import {Paper , Tabs, Tab, AppBar, Typography, Box} from '@material-ui/core/';
import PropTypes from 'prop-types';
/********** COMPONENTS **********/
import Los40AfiliadosPorMunicipios from '../Los40AfiliadosPorMunicipios';
import InformacionGeneral from '../InformacionGeneral/index';
import DatosDeAfiliados from '../DatosDeAfiliaciones/index';
/********** STYLES **********/
import { useStyles } from "./styles";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`} aria-labelledby={`scrollable-force-tab-${index}`} {...other}>
            {value === index && (
                <Box p={3}> <Typography>{children}</Typography> </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node, index: PropTypes.any.isRequired, value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const ScrollableTabsButtonForce = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    return (
        <Paper  className={classes.root} elevation={0}>
            <AppBar position="static" color="white" elevation={0}>
                <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary"
                    variant="scrollable"
                    scrollButtons="on"
                    aria-label="scrollable force tabs example"
                >
                    <Tab label="Información General" icon={<img className={classes.img} alt="complex" src={"/assets/InformacionGeneral.png"} />} {...a11yProps(0)} />
                    {/* <Tab label="Listado de Afiliados" icon={<img className={classes.img} alt="complex" src={"/assets/ReporteListadoAfiliados.png"} />} {...a11yProps(1)} />
                    <Tab label="Total de afiliados de los 40" icon={<img className={classes.img} alt="complex" src={"/assets/Reporte.png"} />} {...a11yProps(2)} /> */}
                </Tabs>
            </AppBar>
            {/* Informacion general */}
            <TabPanel value={value}  index={0}>
                <InformacionGeneral/>
            </TabPanel>
            {/* Datos de afiliados */}
            {/* <TabPanel value={value} index={1}>
                <DatosDeAfiliados/>
            </TabPanel> */}
            {/* los 40, afiliados por municipios */}
            {/* <TabPanel value={value} index={2}>
                <Los40AfiliadosPorMunicipios/>
            </TabPanel> */}
        </Paper>
    );
}

export default ScrollableTabsButtonForce;